import { Routes } from '@angular/router';
import { SigninManager } from 'sham-components/shared/auth';
import { CustomerSupportSigninManager } from './services/signin-manager.service';
import { dashboardGuestGuard, dashboardRoleGuard } from 'sham-components/services';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [dashboardGuestGuard('CustomerSupport', ['/app'])],
    loadComponent: () =>
      import('./features/auth/signin/signin').then((x) => x.Signin),
    providers: [{ provide: SigninManager, useClass: CustomerSupportSigninManager }],
  },
  { path: 'signin', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'app',
    canActivate: [dashboardRoleGuard('CustomerSupport', ['/login'])],
    canActivateChild: [dashboardRoleGuard('CustomerSupport', ['/login'])],
    loadComponent: () =>
      import('./layouts/dashboard/dashboard').then((x) => x.Dashboard),
    loadChildren: () => import('./shared/dashboard-routes'),
  },

  { pathMatch: 'full', path: '', redirectTo: '/login' },
  { path: '**', redirectTo: '/login' },
];
